module.exports = __webpack_public_path__ + "img/x-circle-outline.164c254f.svg";